import React, { useState } from "react";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import ServiceFilter from "../../../app/core/components/UserFilter/ServiceFilter";
import { t } from "i18next";
import { useAddServiceGroupMutation } from "../../api/admin/ServiziApi";
import { toast } from "react-toastify";

const AddService = ({ dataService, isLoading, group, onClose }) => {
  const [service, setService] = useState();

  const [addService] = useAddServiceGroupMutation();

  const handleSave = () => {
    const body = {
      idCategory: group.id,
      idPracticeService: service.id,
    };

    addService({ group: body })
      .then((res) => {
        if (res.data.Result !== 1) {
          toast.error(t("ServiceNotAddGroup"));
          return;
        }
        toast.success(t("ServiceAddGroup"));
        onClose();
      })
      .catch(() => {
        toast.error(t("ServiceNotAddGroup"));
      });
  };

  return (
    <div>
      <h2 className="text-center">{t("AddService")} </h2>

      <div className="flex space-x-10 p-4">
        <div className="w-full">
          <div className="flex flex-col">
            <ServiceFilter
              selected={service}
              setSelected={(e) => setService(e)}
              dataList={dataService}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>

      <div className="flex w-full justify-around mt-10">
        <CoreButton
          className={"btn-round"}
          variant="contained"
          testo={t("Save")}
          onClick={handleSave}
          disabled={isLoading}
        />
      </div>
    </div>
  );
};

export default AddService;
